<template>
  <section id="wheel">
      <img src="./../../assets/arrow-down.svg" alt="">
      <ul class="roster" ref="wheel">
        <li class="name" v-for="(person, index) in roster" :key="person.id" :style="{ transform: `translateX(-50%) rotateZ(-${(settings.deg * index).toFixed(2)}deg)` }" :class="{selected : (index+1) == selected}">{{person.name}}</li>
      </ul>
  </section>
</template>

<script>
import anime from 'animejs';

export default {
    name: 'Wheel',
    props: {
      roster: Array
    },
    data(){
      return {
        toBeExcluded: null,
        selected: null,
        spin: false,
      }
    },
    methods: { 
      async trigger(){
      
        await this.$store.commit('excludeName', this.toBeExcluded);

        if(this.roster.length){

          let randomIndex = Math.floor(Math.random()*this.roster.length);
          let rotations = (90 + (this.settings.deg * randomIndex) + (360*3));
          this.selected = null;
          this.toBeExcluded = this.roster[randomIndex].id;

          let spin = anime({
            targets: this.$refs.wheel,
            duration: 4000,
            easing: 'cubicBezier(.05, .05, .1, 1)',
            rotateZ: [`90deg`, `${rotations}deg`],
          })

          spin.finished.then(() => {
            this.$store.commit('updatePicked', this.roster[randomIndex]);
            this.selected = randomIndex+1;
            this.spin = false;
          })
        
        } else {
          this.toBeExcluded = null // reset excluder
        }
      }
    },
    computed: {
      settings(){
        return {
          currentDeg: 0,
          deg: 360/this.roster.length,
          offset: (360/this.roster.length)/2,
          selectedIndex: 0
        }
      }
    }
}
</script>

<style lang="scss">
@import './../../scss/variables';

#wheel {
  height: 100vh;
  width: 100vw;
  @include center;
  flex-direction: column;
  padding: 1rem;
  overflow: hidden;

  > img {
    width: 2rem;
  }

  .roster {
    padding: 0;
    width: 100%;
    height: 100%;
    max-width: 70vh;
    max-height: 70vh;
    position: relative;
    @include center;
    transform: rotateZ(90deg);

    .name {
      padding: 0;
      margin: 0;
      font-size: 1rem;
      position: absolute;
      width: 50%;
      transform-origin: right center;
      transform: translateX(-50%) rotateZ(0deg);
      transition: color .4s ease;
      opacity: 1;

      &.selected {
        color: white;
      }
    }

  }

}
</style>